import React from 'react';
import { motion } from 'framer-motion';
import { FiShield, FiBriefcase, FiHome, FiActivity } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const niches = [
  {
    title: 'SSDI CALLS',
    icon: FiShield,
    desc: 'High-intent Social Security Disability transfers and inbound calls.',
    color: 'from-blue-500 to-indigo-600'
  },
  {
    title: 'CPA CALLS',
    icon: FiBriefcase,
    desc: 'Qualified tax debt and professional CPA service inquiries delivered via phone.',
    color: 'from-emerald-500 to-teal-600'
  },
  {
    title: 'HOME SERVICE CALLS',
    icon: FiHome,
    desc: 'HVAC, Plumbing, and Roofing calls from ready homeowners.',
    color: 'from-orange-500 to-red-600'
  }
];

const Niches = () => {
  return (
    <section id="niches" className="py-32 bg-slate-950 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-20">
          <h2 className="text-indigo-500 font-bold tracking-widest uppercase text-xs mb-3">Our Verticals</h2>
          <h3 className="text-4xl md:text-5xl font-black text-white tracking-tighter">SPECIALIZED CALL TRAFFIC</h3>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {niches.map((niche, i) => (
            <motion.div
              key={i}
              whileHover={{ y: -15, rotateX: 5, rotateY: 5 }}
              className="group relative bg-slate-900 border border-white/5 p-10 rounded-[2.5rem] overflow-hidden transition-all duration-500 hover:shadow-[0_30px_60px_-15px_rgba(0,0,0,0.7)]"
              style={{ perspective: 1000 }}
            >
              <div className={`absolute top-0 left-0 w-2 h-full bg-gradient-to-b ${niche.color}`}></div>
              <div className="w-16 h-16 bg-white/5 rounded-2xl flex items-center justify-center mb-8 group-hover:scale-110 transition-transform">
                <SafeIcon icon={niche.icon} className="text-3xl text-white" />
              </div>
              <h4 className="text-2xl font-black text-white mb-4 tracking-tight italic">{niche.title}</h4>
              <p className="text-slate-400 leading-relaxed font-medium">
                {niche.desc}
              </p>
              <div className="mt-8 flex items-center gap-2 text-white/20 group-hover:text-white/60 transition-colors">
                <SafeIcon icon={FiActivity} />
                <span className="text-xs font-bold tracking-widest">ACTIVE VERTICAL</span>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Niches;